import Store from "../store/index";

export const Vue2FiltersConfig = {
    bytes: {
        decimalDigits: 2,
    },
    capitalize: {
        onlyFirstLetter: false,
    },
    currency: Store.getters["configs/currency"],
    number: {
        decimalSeparator: ".",
        format: "0",
        thousandsSeparator: ",",
    },
    ordinal: {
        includeNumber: false,
    },
    percent: {
        decimalDigits: 2,
        multiplier: 100,
    },
    pluralize: {
        includeNumber: false,
    },
};
